import React from 'react';

import { getTabIndex } from '../../utils';
import SideBarNav from '../../components/molecule/SideBarNav';

import Workouts from './Workouts';
import Transfer from './Transfer';
import WelcomeVideo from './Welcome';
import ReleaseNotes from './ForceUpgrade';
import PromoCode from './PromoCode';

const baseRoute = '/staff';
const Staff = ({
  match,
  ...other
}) => {
  const navTabs = [
    {
      label: 'Program Generator',
      header: 'Program Generator',
      path: `${baseRoute}/workouts`,
      component: <Workouts match={match} {...other} />,
      props: { to: `${baseRoute}/workouts` }
    },
    {
      label: 'Transfer Funds',
      header: 'Transfer Funds',
      path: `${baseRoute}/transfer`,
      component: <Transfer match={match} {...other} />,
      props: { to: `${baseRoute}/transfer` }
    },
    {
      label: 'Welcome Video',
      header: 'Welcome Video',
      path: `${baseRoute}/welcome`,
      component: <WelcomeVideo match={match} {...other} />,
      props: { to: `${baseRoute}/welcome`}
    },
    {
      label: 'Release Note',
      header: 'Release Note',
      path: `${baseRoute}/release`,
      component: <ReleaseNotes match={match} {...other} />,
      props: { to: `${baseRoute}/release`}
    },
    {
      label: 'Promo Code',
      header: 'Promo code',
      path: `${baseRoute}/promo`,
      component: <PromoCode match={match} {...other} />,
      props: { to: `${baseRoute}/promo`}
    }
  ];

  return (
    <SideBarNav
      value={getTabIndex(match.url,navTabs)}
      navComponents={navTabs}
      {...other}
    />
  );
}

Staff.propTypes = {

};

export default Staff;
